module.exports = __webpack_public_path__ + "Roboto-Medium-webfont.1d2af757de4340d6b644.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/gfurtado/Projects/v2.3 (ng4 2.1 only)/Angular 4 CLI/app/src/assets/fonts/roboto/Roboto-Medium-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Medium-webfont.ttf
// module chunks = styles